import has from '@dojo/framework/core/has';
const breadcrumbs = has('use-micro-view')
    ? [
        {
            widget: 'Widget',
            name: 'quiz-breadcrumbs',
            realwidget: 'MicroBreadcrumbs'
        }
    ]
    : [];
export const viewFromLpl = (lpl) => {
    const { widget } = lpl;
    const params = { ...lpl };
    delete params['widget'];
    return { widget, params };
};
export const assessment = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'assessment-view',
        kids: [
            {
                widget: 'Group',
                name: 'assessment-body',
                classes: ['assessment-body'],
                kids: [
                    ...breadcrumbs,
                    {
                        widget: 'Widget',
                        name: 'assessment-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
export const practice = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'practice-view',
        kids: [
            {
                widget: 'Group',
                name: 'practice-body',
                classes: ['practice-body'],
                kids: [
                    ...breadcrumbs,
                    {
                        widget: 'Widget',
                        name: 'practice-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
export const bonus = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'bonusquiz-view',
        kids: [
            {
                widget: 'Group',
                name: 'bonusquiz-body',
                classes: ['bonusquiz-body'],
                kids: [
                    ...breadcrumbs,
                    {
                        widget: 'Widget',
                        name: 'bonus-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
export const posttest = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'posttest-view',
        kids: [
            {
                widget: 'Group',
                name: 'posttest-body',
                classes: ['posttest-body'],
                kids: [
                    ...breadcrumbs,
                    {
                        widget: 'Widget',
                        name: 'posttest-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
export const quiz = (quizid, title) => {
    return {
        widget: 'LPView',
        view: 'quiz-view',
        kids: [
            {
                widget: 'Group',
                name: 'quiz-body',
                classes: ['quiz-body'],
                kids: [
                    ...breadcrumbs,
                    {
                        widget: 'Widget',
                        name: 'general-quiz',
                        realwidget: 'quiz',
                        jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
                    }
                ]
            }
        ]
    };
};
